/**
 * 微信JSSDK工具类
 */
class WeixinJSSDK {
  constructor() {
    this.init();
  }

  /**
   * 初始化微信JSSDK
   */
  init() {
    // 检查是否在微信环境中
    if (this.isWechat()) {
      this.loadJSSDK();
    } else {
      console.log("非微信环境，跳过微信JSSDK初始化");
    }
  }

  /**
   * 判断是否在微信环境中
   */
  isWechat() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
  }

  /**
   * 加载微信JSSDK
   */
  loadJSSDK() {
    // 如果还没有引入微信JSSDK，则动态加载
    if (!window.wx) {
      console.error('请先引入微信JSSDK');
      return;
    }

    // 获取签名信息
    this.getSignature(window.location.href);
  }

  /**
   * 获取签名信息
   */
  async getSignature(url) {
    try {
      // 这里需要后端提供签名接口
      const response = await fetch('/api/wechat/signature', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: url.split('#')[0]
        })
      });
      
      const data = await response.json();
      if (data.success) {
        this.configWXJSSDK(data.data);
      } else {
        console.error('获取微信签名失败:', data.message);
      }
    } catch (error) {
      console.error('请求微信签名接口失败:', error);
    }
  }

  /**
   * 配置微信JSSDK
   */
  configWXJSSDK(signatureData) {
    const wx = window.wx;

    wx.config({
      debug: false,
      appId: signatureData.appId,
      timestamp: signatureData.timestamp,
      nonceStr: signatureData.nonceStr,
      signature: signatureData.signature,
      jsApiList: [
        'updateAppMessageShareData', // 自定义"分享给朋友"及"分享到QQ"按钮的分享内容
        'updateTimelineShareData', // 自定义"分享到朋友圈"及"分享到QQ空间"按钮的分享内容
        'onMenuShareTimeline', // 监听"分享到朋友圈"按钮点击
        'onMenuShareAppMessage' // 监听"分享给朋友"按钮点击
      ]
    });

    wx.ready(() => {
      this.setShareData();
    });

    wx.error((res) => {
      console.error('微信JSSDK配置失败:', res);
    });
  }

  /**
   * 设置分享数据
   * @param {Object} customShareData - 自定义分享数据 (可选)
   * @param {string} customShareData.title - 分享标题
   * @param {string} customShareData.desc - 分享描述
   * @param {string} customShareData.link - 分享链接
   * @param {string} customShareData.imgUrl - 分享图片
   */
  // AI-Generated Begin
  setShareData(customShareData = null) {
    // 默认分享数据
    const defaultShareData = {
      title: document.title || '春阳台，塱头乡村振兴公益项目标志性艺文中心，岭南新地标',
      desc: document.querySelector('meta[name="description"]')?.getAttribute('content') || 
            '春阳台艺文中心, 春阳台艺术文化中心, 张永和, 张永和设计, 花都春阳台, 广州春阳台, 塱头乡村振兴, 塱头模式, 岭南新地标, 岭南文化地标, 大湾区文化地标, 贾科梅蒂在广州, 贾科梅蒂在塱头, 非常建筑设计, 陈献章春阳台, 陈白沙春阳台',
      link: window.location.href,
      imgUrl: 'https://a.vpimg2.com/upload/vmotheradmin/charityTopicPhoto/2026/0105/c2b95fab-3294-4ba8-940c-9e2f8e329122.jpg', // 固定分享图片
      success: function() {
        console.log('分享成功');
      },
      cancel: function() {
        console.log('取消分享');
      }
    };

    // 合并自定义分享数据
    const shareData = customShareData ? { ...defaultShareData, ...customShareData } : defaultShareData;

    // 新版API
    if (window.wx) {
      // 分享到朋友圈
      window.wx.updateTimelineShareData(shareData);
      
      // 分享给朋友
      window.wx.updateAppMessageShareData(shareData);
    }
  }
  // AI-Generated End
}

// 导出实例
const weixinJSSDK = new WeixinJSSDK();
export default weixinJSSDK;